import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextButton, Modal, styled, useMediaQuery } from 'bonfire-kindling';
import { ModalTitle } from 'components';

const StyledActionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    padding: `0 ${theme.spacing(3)}`,
    marginBottom: theme.spacing(3),
  },
}));

export default function OpportunitySharedActions({
  IsBonfireOrganization,
  ExternalLink,
  isFollowing,
  openBonfireOpportunity,
  toggleIsFollowing,
  ...props
}) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobileWidth = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const followButton = (
    <TextButton
      variant={isFollowing ? 'contained' : 'outlined'}
      sx={
        // Override kindling darken on focus
        isFollowing
          ? {
              '&:focus': {
                backgroundColor: theme => theme.palette.primary.main,
                borderColor: theme => theme.palette.primary.main,
              },
            }
          : {}
      }
      label={isFollowing ? t('opportunities.project.unfollow') : t('opportunities.project.follow')}
      onClick={toggleIsFollowing}
    />
  );

  const onClose = () => setIsModalOpen(false);

  return (
    <StyledActionContainer {...props}>
      {!isMobileWidth && followButton}
      {(IsBonfireOrganization || ExternalLink) && (
        <TextButton
          size="small"
          onClick={e => {
            if (IsBonfireOrganization) {
              openBonfireOpportunity(e);
            } else {
              setIsModalOpen(true);
            }
          }}
          label={t('opportunities.project.go_to_project')}
          variant="text"
          sx={{
            color: theme => theme.palette.primary.main,
            textDecoration: 'underline',
            fontWeight: 600,
            marginTop: 1,
          }}
        />
      )}
      {isMobileWidth && followButton}
      <Modal
        open={isModalOpen}
        onClose={onClose}
        aria-labelledby="leaving-pv-modal-title"
        aria-describedby="leaving-pv-modal-subtitle"
        size={isMobileWidth ? 'tiny' : 'medium'}
      >
        <ModalTitle
          onClose={onClose}
          titleId="leaving-pv-modal-title"
          subtitleId="leaving-pv-modal-subtitle"
          subtitle={t('opportunities.project.leaving_pv_modal_subtitle')}
        >
          {t('opportunities.project.leaving_pv_modal_title')}
        </ModalTitle>
        <Box
          display="flex"
          padding={isMobileWidth ? '1rem 1rem' : '1rem 2rem'}
          justifyContent="end"
        >
          <TextButton
            variant="outlined"
            onClick={onClose}
            label={t('opportunities.project.leaving_pv_modal_cancel')}
            sx={{ marginRight: 3 }}
          />
          <TextButton
            component="a"
            rel="noreferrer noopener"
            target="_blank"
            href={ExternalLink}
            label={t('opportunities.project.leaving_pv_modal_continue')}
            onClick={onClose}
          />
        </Box>
      </Modal>
    </StyledActionContainer>
  );
}
